/**
 * @desc tea 国际化
 * @time 2023-07-31 16:11:53
 * @user simxin
 */

import { i18n } from '@tencent/tea-app';
import { translation } from '@i18n/translation';

/**
 * @desc 初始化国际化词条
 */
i18n.init({ translation });
